import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { selectLayout } from "../ducks/shopSelectors";
import ProductsListCart from "../components/ProductsListCart";
import {
  cancelOrder,
  refreshCachedCosts,
  incrementOrderQtt,
  decrementOrderQtt,
} from "../ducks/shoppingCartSlice";
import useGoTo from "../hooks/useGoTo";
import { requireProducts } from "../ducks/productsSlice";
import { STATE_STEP } from "../ducks/consts";
import Loading from "../components/Loading";
import buildCartItems from "../utils/cartItems";
import ProductsListCartTotem from "../components/ProductsListCartTotem";

export default function CartView() {
  const goTo = useGoTo();
  const dispatch = useDispatch();
  const questionsStateByProduct = useSelector(
    (state) => state.products.questionsStateByProduct,
  );
  const shop = useSelector((state) => state.shop);
  const layout = useSelector(selectLayout);
  const products = useSelector((state) => state.products.items);
  const questionsByProduct = useSelector(
    (state) => state.products.questionsByProduct,
  );
  const productOrders = useSelector(
    (state) => state.shoppingCart.productOrders,
  );
  const cachedCostPerOrder = useSelector(
    (state) => state.shoppingCart.cachedCostPerOrder,
  );
  const cachedCostPerOrderOld = useSelector(
    (state) => state.shoppingCart.cachedCostPerOrderOld,
  );
  const answersByOrder = useSelector(
    (state) => state.shoppingCart.answersByOrder,
  );

  const orders = productOrders.filter((o) => o.commited);

  const orderedProducts = buildCartItems(orders, {
    products,
    questionsByProduct,
    answersByOrder,
    cachedCostPerOrder,
    cachedCostPerOrderOld,
    kilogramStep: shop.kilogramStep,
  });

  React.useEffect(() => {
    orders.forEach((order) => dispatch(requireProducts(order.productId)));
  }, [dispatch, orders]);

  // recalcula ao abrir a sacola: uma promocao que comecou ou acabou desde a
  // ultima interacao aparece aqui, e nao so depois de o pedido ser recusado
  // pela conferencia de preco da API.
  React.useEffect(() => {
    dispatch(refreshCachedCosts());
  }, [dispatch]);

  const sacolaVazia = orders.length === 0;

  // Este redirect ficava no corpo do render, e isso quebrava o envio do pedido:
  // ao finalizar, o CheckoutForm limpa o carrinho e navega para a tela de
  // status. Como o React re-renderiza a subárvore inscrita no redux
  // independentemente do Router, o CartView renderizava com a sacola já vazia e
  // chamava goTo("/") DEPOIS da navegação para o status — sobrescrevendo-a. O
  // usuário enviava o pedido e voltava para a home.
  //
  // Além de sair da fase de render, a guarda de rota é necessária: só faz
  // sentido mandar para a home quem esvaziou a sacola estando no checkout.
  React.useEffect(() => {
    if (!sacolaVazia) return;
    if (!window.location.pathname.endsWith("/checkout")) return;
    goTo("/");
  }, [sacolaVazia, goTo]);

  if (sacolaVazia) {
    return (
      <div className="empty-state">
        <p>Sacola vazia. Volte e escolha algum produto!</p>
      </div>
    );
  }

  const isLoading = Object.keys(questionsStateByProduct)
    .map((key) => questionsStateByProduct[key])
    .some((step) => step === STATE_STEP.LOADING);

  if (isLoading) {
    return <Loading message="Carregando carrinho..." />;
  }

  const qttPayload = (item) => ({
    uuid: item.uuid,
    isKilogram: item.isKilogram,
    kilogramStep: shop.kilogramStep,
  });

  const cartActions = {
    onEdit: (item) => goTo(`/product/${item.id}/order/${item.uuid}`),
    onRemove: (item) => dispatch(cancelOrder({ uuid: item.uuid })),
    onIncrement: (item) => dispatch(incrementOrderQtt(qttPayload(item))),
    onDecrement: (item) => dispatch(decrementOrderQtt(qttPayload(item))),
  };

  if (layout.checkout === "totem") {
    return (
      <ProductsListCartTotem products={orderedProducts} {...cartActions} />
    );
  }

  return <ProductsListCart products={orderedProducts} {...cartActions} />;
}
